// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"r95Ml","titleWrapper":"S9gXl","leftWrapper":"_2hzeS","needHelpWrapper":"_1_ytN","needHelp":"_3VBuR","modalWrappers":"_3dbMS","headings":"_15KaZ"};